import isEmpty from 'lodash/isEmpty';
import { optionActions } from 'core/Option';
import { useTranslation } from 'react-i18next';
import {
    ButtonFooter,
    ExpandButton,
    FormGroup,
    Input,
    Modal
} from 'mol-ui';
import {
    Col,
    Row
} from 'reactstrap';
import {
    ConfirmationModal,
    ErrorMessage,
    ListingLayout
} from 'views/components';
import {
    Container,
    DataCol,
    DataContainer,
    DataRow,
    HeaderCol,
    HeaderRow,
    Link,
    Message,
    ModalContainer
} from './styled';
import React, { useEffect, useState } from 'react';
import {
    useDispatch,
    useSelector
} from 'hooks';

const PolyOffices = () => {

    const {
        polyOffices: list,
        polyOfficesLoading: loading
    } = useSelector('option');

    const dispatch = useDispatch();
    const { t } = useTranslation();

    const [deleteConfirm, setDeleteConfirm] = useState(0);
    const [errors, setErrors] = useState({});
    const [modalEdit, setModalEdit] = useState(false);
    const [selectedPolyOffice, setSelectedPolyOffice] = useState({});
    
    useEffect(() => {
        dispatch(optionActions.getPolyOffices());
    }, []);

    const clearErrors = id => setErrors(errors => {
        delete errors[id];
        return errors;
    });

    const onAccept = () => {
        const { id } = selectedPolyOffice;
        if (validate()) {
            if (!!id) {
                dispatch(optionActions.updatePolyOffice({
                    ...selectedPolyOffice,
                    id
                }));
            } else {
                dispatch(optionActions.createPolyOffice(selectedPolyOffice));
            }
            onCancelEdit();
        }
    };

    const onCancelEdit = () => {
        setErrors({});
        setSelectedPolyOffice({});
        setModalEdit(false);
    };

    const onDelete = action => {
        if (action === 'confirm') {
            dispatch(optionActions.deletePolyOffice(deleteConfirm));
        }
        setDeleteConfirm(0);
    };

    const onEditPrompt = (polyOffice = {}) => {
        setErrors({});
        setSelectedPolyOffice(polyOffice);
        setModalEdit(true);
    };

    const onFilterChange = ({ search }) => {
        dispatch(optionActions.getPolyOffices({
            search
        }));
    };

    const polyOfficeChange = (id, value) => {
        clearErrors(id);
        setSelectedPolyOffice(selectedPolyOffice => ({
            ...selectedPolyOffice,
            [id]: value
        }));
    };

    const validate = () => {
        const { address, description, name } = selectedPolyOffice;
        const newErrors = {
            ...(!address && { address: t('Requerido') }),
            ...(!description && { description: t('Requerido') }),
            ...(!name && { name: t('Requerido') })
        };
        setErrors(newErrors);
        return isEmpty(newErrors);
    };

    const { address, description, name } = selectedPolyOffice;

    return (
        <>
            <ConfirmationModal
                actionHandler={ onDelete }
                active={ !!deleteConfirm }
                title={ t('¿Desea eliminar este policonsultorio?') }
            />
            <Modal active={ modalEdit } borderRadius="25px" width="500px" onToggle={ onCancelEdit }>
                <ModalContainer>
                    <Row>
                        <Col xs="12">
                            <FormGroup label={ t('Nombre') }>
                                <Input
                                    error={ errors.name }
                                    hasError={ !!errors.name }
                                    value={ name ?? '' }
                                    onChange={ value => polyOfficeChange('name', value) }
                                />
                            </FormGroup>
                        </Col>
                        <Col xs="12">
                            <FormGroup label={ t('Dirección') }>
                                <Input
                                    error={ errors.address }
                                    hasError={ !!errors.address }
                                    value={ address ?? '' }
                                    onChange={ value => polyOfficeChange('address', value) }
                                />
                            </FormGroup>
                        </Col>
                        <Col xs="12">
                            <FormGroup label={ t('Descripción') }>
                                <Input
                                    error={ errors.description }
                                    height="100px"
                                    type="area"
                                    value={ description ?? '' }
                                    onChange={ value => polyOfficeChange('description', value) }
                                />
                                <ErrorMessage error={ errors.description } />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <ButtonFooter>
                                <ExpandButton danger caption={ t('Cancelar') } size={ 100 } onClick={ onCancelEdit } />
                                <ExpandButton caption={ t('Confirmar') } size={ 100 } onClick={ onAccept } />
                            </ButtonFooter>
                        </Col>
                    </Row>
                </ModalContainer>
            </Modal>
            <ListingLayout
                loading={ loading }
                onFilterChange={ onFilterChange }
            >
                <Container>
                    <HeaderRow>
                        <HeaderCol xs="3">{ t('Nombre') }</HeaderCol>
                        <HeaderCol xs="3">{ t('Dirección') }</HeaderCol>
                        <HeaderCol xs="4">{ t('Descripción') }</HeaderCol>
                        <HeaderCol cursor="pointer" xs="2" onClick={ onEditPrompt }>
                            + { t('Nuevo policonsultorio') }
                        </HeaderCol>
                    </HeaderRow>
                    {
                        !isEmpty(list)
                            ? <>
                                <DataContainer>
                                    {
                                        list.map((polyOffice, index) => {
                                            const {
                                                address,
                                                description,
                                                id,
                                                name
                                            } = polyOffice;
                                            return (
                                                <DataRow key={ index }>
                                                    <DataCol xs="3">{ name }</DataCol>
                                                    <DataCol xs="3">{ address }</DataCol>
                                                    <DataCol xs="4">{ description }</DataCol>
                                                    <DataCol xs="2">
                                                        <Link onClick={ () => onEditPrompt(polyOffice) }>{ t('Editar') }</Link>
                                                        <Link>-</Link>
                                                        <Link onClick={ () => setDeleteConfirm(id) }>{ t('Eliminar') }</Link>
                                                    </DataCol>
                                                </DataRow>
                                            );
                                        })
                                    }
                                </DataContainer>
                            </>
                            : <Message>
                                { t('No hay policonsultorios para mostrar') }
                            </Message>
                    }
                </Container>
            </ListingLayout>
        </>
    );
};

export default PolyOffices;
